const remote = {
    apiURL: "https://api.com"
}

const local = {
    apiURL: "http://localhost:3000"
}

export default local;